import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import Dropdown from '../Dropdown';
import moment from 'moment';

var DurationDropdown = function (_Component) {
  _inherits(DurationDropdown, _Component);

  function DurationDropdown() {
    _classCallCheck(this, DurationDropdown);

    var _this = _possibleConstructorReturn(this, (DurationDropdown.__proto__ || Object.getPrototypeOf(DurationDropdown)).call(this));

    var maxHours = 8;
    var minutesInHour = 60;
    var maxDuration = minutesInHour * maxHours;
    _this.options = [];
    for (var i = 15; i <= maxDuration; i += 15) {
      /* after 40mins, only display every 30mins */
      if (i > 45 && i % 30 !== 0) {
        continue;
      }

      /* after 3h00, only display every hour */
      if (i > 180 && i % 60 !== 0) {
        continue;
      }
      var label = '';
      var duration = moment.duration(i, 'minutes');
      if (duration.hours() > 0) {
        label += duration.hours() + ':';
      }

      label += duration.minutes();
      if (duration.minutes() == 0) {
        label += '0h'; /* to display 1:00h */
      }
      if (duration.hours() == 0) {
        label += 'mins';
      }
      _this.options.push({ label: label, value: i * 60 });
    }
    return _this;
  }

  _createClass(DurationDropdown, [{
    key: 'render',
    value: function render() {
      var paramName = this.props.paramName;

      return React.createElement(Dropdown, _extends({}, this.props, { className: 'dropdown-duration', hideArrow: true, options: this.options }));
    }
  }]);

  return DurationDropdown;
}(Component);

export default DurationDropdown;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/DurationDropdown/index.js
// module id = 1067
// module chunks = 0